<template lang="pug">
    ._selector
      label(for='indexList') View Indexes in:
      div._input
        select-input#indexList(
          v-model='value'
          :options='options')
      app-button._button(@click='goToManualIndex()' :loading='loading') Go
</template>
<script>
import AppButton from '@/components/app-button'
import SelectInput from '@/components/select-input'

export default {
  name: 'manual-index-search-widget',
  components: {
    AppButton,
    SelectInput
  },
  props: {
    sourceId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      loading: false,
      value: 18225,
      options: [
        { name: 'Bartholomew County, IN', value: 18220 },
        { name: 'Boone County, IN', value: 18225 },
        { name: 'Brown County, IN', value: 18208 },
        { name: 'Carroll County, IN', value: 18213 },
        { name: 'Daviess County, IN', value: 18219 },
        { name: 'Dearborn County, IN', value: 18176 },
        { name: 'Dubois County, IN', value: 18150 },
        { name: 'Hancock County, IN', value: 18174 },
        { name: 'Kosciusko County, IN', value: 18172 },
        { name: 'Martin County, IN', value: 18221 },
        { name: 'Monroe County, IN', value: 18214 },
        { name: 'Montgomery County, IN', value: 18181 },
        { name: 'Parke County, IN', value: 18196 },
        { name: 'Shelby County, IN', value: 18136 },
        { name: 'Vigo County, IN', value: 18156 },
        { name: 'Vermillion County, IN', value: 18185 },
        { name: 'Wells County, IN', value: 18227 }
      ]
    }
  },
  mounted () {
    this.value = this.options.map(opt => opt.value)
      .includes(this.sourceId) ? this.sourceId : this.options[0].value
  },
  methods: {
    goToManualIndex () {
      if (this.$route.path !== `/in/recorder/ManualIndex/${this.value}`) {
        this.loading = true
      }
      this.$navigateTo({
        path: `/recorder/ManualIndex/${this.value}`
      })
    }
  }
}
</script>
<style lang="scss" module>
  .selector {
    display: flex;
    flex-direction: row;
    align-items: center;
    > div {
      margin: 0.5rem;
    }
    > label {
      font-weight: bold;
    }
    > label, .button {
      flex-shrink: 0;
    }
  }
  .input, .selector {
    width: 100%;
  }
</style>
